import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import isArray from 'lodash/isArray';
import getKey from 'lodash/get';

import AntLayout from 'antd/lib/layout';

import Admin from './Admin';
import { HeaderContent } from './Header';

import mix from '../modules/mix';
import Configurable from './Mixins/Configurable';
import SuperProps from './Mixins/SuperProps';

import './Page.less';

export default class Page extends mix(Component, Configurable, SuperProps) {
  static config = {
    ClassName: 'Page',
    isNotFound: () => false,
    renderNotFound: props => <h1>{props.notFoundMessage}</h1>,
    notFoundMessage: 'Content Not Found',
    headerTitleKey: 'name',
    LayoutComponent: AntLayout.Content,
    redirect: [],
    getRedirect: (props) => {
      for (let i = 0; i < props.redirect.length; i++) {
        const redirect = props.redirect[i](props);
        if (redirect) {
          return redirect;
        }
      }
      return undefined;
    },
    skip: [],
    getSkip: props => Admin.test(
      props.skip || [],
      props,
      true,
      true,
    ),
    getHidden: props => (
      props.hidden === true || Admin.test(
        props.hidden || [],
        props,
        true,
        true,
      )
    ),
    hideSidebar: false,
    getHideSidebar: (props) => (
      props.hideSidebar === true || Admin.test(
        props.hideSidebar || [],
        props,
        true,
        true,
      )
    ),
    hideHeader: false,
    getHideHeader: (props) => (
      props.hideHeader === true || Admin.test(
        props.hideHeader || [],
        props,
        true,
        true,
      )
    ),
    hideFloating: true,
    getHideFloating: (props) => (
      props.hideFloating === true || Admin.test(
        props.hideFloating || [],
        props,
        true,
        true,
      )
    ),
    renderHeaderTitle: (props) => {
      if (props.form) {
        const formValue = props.form.getFieldValue(props.headerTitleKey);
        if (formValue) {
          return `${formValue}`;
        }
      }
      if (props.data) {
        const dataValue = getKey(props.data, props.headerTitleKey);
        if (dataValue) {
          return `${dataValue}`;
        }
      }
      return props.headerTitle || props.title;
    },
    renderHeaderDescription: props => (
      props.headerDescription || null
    ),
    renderHeaderRight: () => null,
    style: {},
  }

  static create(config, keys = []) {
    const staticConfig = this.getConfig(config, keys);
    staticConfig.redirect = Admin.compileFromLibrary(
      staticConfig.redirect,
      true,
    );
    staticConfig.skip = Admin.compileFromLibrary(
      staticConfig.skip,
      true,
    );
    staticConfig.hidden = isArray(staticConfig.hidden)
    ? Admin.compileFromLibrary(staticConfig.hidden, true)
    : staticConfig.hidden;
    staticConfig.hideSidebar = isArray(staticConfig.hideSidebar)
    ? Admin.compileFromLibrary(staticConfig.hideSidebar, true)
    : !!staticConfig.hideSidebar;
    staticConfig.hideHeader = isArray(staticConfig.hideHeader)
    ? Admin.compileFromLibrary(staticConfig.hideHeader, true)
    : !!staticConfig.hideHeader;
    staticConfig.hideFloating = isArray(staticConfig.hideFloating)
    ? Admin.compileFromLibrary(staticConfig.hideFloating, true)
    : !!staticConfig.hideFloating;
    staticConfig.render = (props) => {
      const PageComponent = this;
      return (
        <PageComponent
          // eslint-disable-next-line react/no-this-in-sfc
          {...this.getProps(staticConfig, config, props)}
        />
      );
    };
    return staticConfig;
  }

  constructor(props) {
    super(props);
    this.state = {};
    this.state.loading = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.unmounted = false;
    if (this.props.adminPageRef) {
      this.props.adminPageRef.current = this;
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    this.unmounted = true;
    if (this.props.adminPageRef && this.props.adminPageRef.current === this) {
      this.props.adminPageRef.current = undefined;
    }
  }

  getStatefullProps(...args) {
    return {
      ...super.getStatefullProps(...args),
      pageRef: this,
    };
  }

  getPageTitle() {
    return `${this.state.title || this.props.title}`;
  }

  getDocumentTitle() {
    return `${this.props.titlePrefix}${this.getPageTitle()}`;
  }

  isLoading() {
    return this.state.loading || this.props.loading;
  }

  setLoading(loading = false) {
    this.setState({ loading });
  }

  renderHeaderTitle() {
    return (
      <h1
        key="page-header-title"
        className="page-header-title"
      >
        {this.props.renderHeaderTitle(this.props)}
      </h1>
    );
  }

  renderHeaderDescription() {
    const description = this.props.renderHeaderDescription(this.props);
    if (!description) {
      return null;
    }
    return (
      <p
        key="page-header-description"
        className="page-header-description"
      >
        {this.props.renderHeaderDescription(this.props)}
      </p>
    );
  }

  renderHeaderRight() {
    return this.props.renderHeaderRight(this.props);
  }

  renderHeader() {
    return (
      <div key="page-header" className="page-header">
        <div className="page-header-left">
          {this.renderHeaderTitle()}
          {this.renderHeaderDescription()}
        </div>
        <div className="page-header-right">
          {this.renderHeaderRight()}
        </div>
      </div>
    );
  }

  renderLoader() { // eslint-disable-line class-methods-use-this
    return <h1>Loading...</h1>;
  }

  renderFound() { // eslint-disable-line class-methods-use-this
    return <h1>Content</h1>;
  }

  renderDocumentTitle() {
    return (
      <DocumentTitle
        key="document-title"
        title={this.getDocumentTitle()}
      />
    );
  }

  renderContent() {
    return (
      <div data-component={this.props.ClassName} style={this.props.style}>
        {
          this.isLoading()
          ? this.renderLoader()
          : this.props.isNotFound(this.props)
          ? this.props.renderNotFound(this.props)
          : this.renderFound()
        }
      </div>
    );
  }

  renderAdminHeaderContent() {
    return (
      <HeaderContent
        headerRef={this.props.adminHeaderRef}
        toggleSidebarOpen={this.props.toggleSidebarOpen}
        title={this.getPageTitle()}
      />
    );
  }

  renderWrapper() {
    const { LayoutComponent } = this.props;
    return (
      <>
        {this.renderAdminHeaderContent()}
        <LayoutComponent
          key="content"
          id="content"
        >
          {this.renderDocumentTitle()}
          {this.renderContent()}
        </LayoutComponent>
      </>
    );
  }

  render() {
    return this.renderWrapper();
  }
}

Admin.addToLibrary(
  'Page',
  config => Page.create(config),
);
